// extracted by mini-css-extract-plugin
module.exports = {"Photo":"styles-module--Photo--h04D0","Photo__price":"styles-module--Photo__price--3ifR8"};